import { lazy } from 'react';
import { createRoute } from '@tanstack/react-router';
import { rootRoute } from './__root';

// Code splitting: Lazy load HomePage to reduce initial bundle size
const HomePage = lazy(() => import('@/pages/HomePage'));

export const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  component: HomePage,
});

// 後方互換性のため
export const Route = indexRoute;
